import { Campaign, TrackingOnlyCampaign } from '~/types';
import { useMutation } from '~/utils/rq';

export const useMutateTrackingOnlyCampaign = (campaignId?: string) => {
  const url = `/tracking-only-campaigns/${campaignId ?? ''}`;
  const method = !!campaignId ? 'patch' : 'post';

  return useMutation<TrackingOnlyCampaign, Campaign>(
    {},
    {
      url,
      method
    }
  );
};
